<template functional>
  <div class="card-blank"></div>
</template>

<script>
export default {
  height: 16,
}
</script>
